export class JwtName {
  public static readonly jwtName: string = 'cz-jwt';
}
